import { render, staticRenderFns } from "./TakafulProductPage.vue?vue&type=template&id=b41db57a&"
import script from "./TakafulProductPage.vue?vue&type=script&lang=js&"
export * from "./TakafulProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports